
import AccommodationsTable from "../../../components/Admin/accommodations-table";
//import nuevoAnuncio from "../../../assets/img/nuevo-anuncio.png";
const MisAlquileres = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
          Dashboard
        </h1>
        <p className="text-gray-600 mt-2">
          Gestiona tus alojamientos y reservas
        </p>
      </div>

      <div className="bg-white rounded-lg shadow-sm border">
        <div className="p-4 sm:p-6 border-b">
          <h2 className="text-lg font-semibold text-gray-900">
            Alojamientos Disponibles
          </h2>
          <p className="text-sm text-gray-600 mt-1">
            Administra todos los alojamientos de la plataforma
          </p>
        </div>
        <AccommodationsTable />
      </div>
    </div>
  );
};

export default MisAlquileres;
